export const GENERAL_RISK_FIELD_FALLBACK = 'disabled_generalRiskLevel'

const GENERAL_RISK_FIELD_ALIASES = [
  GENERAL_RISK_FIELD_FALLBACK,
  'generalRiskLevel',
  'nivelRiesgoGeneral',
  'nivel_riesgo_general',
]

const includesGeneralRiskText = value => {
  const normalized = String(value || '').toLowerCase()
  return (
    normalized.includes('generalrisk') ||
    normalized.includes('general_risk') ||
    (normalized.includes('riesgo') && normalized.includes('general')) ||
    (normalized.includes('general') &&
      (normalized.includes('risk') ||
        normalized.includes('riesgo') ||
        normalized.includes('rsgo')))
  )
}

/**
 * Resolve the backend key used for "Nivel de Riesgo General".
 * The API key has changed across deployments, so we detect it dynamically
 * from the category 7 inconveniences payload.
 */
export const resolveGeneralRiskFieldName = (
  itemsInconvenience = [],
  fallback = GENERAL_RISK_FIELD_FALLBACK,
) => {
  const riskItems = Array.isArray(itemsInconvenience)
    ? itemsInconvenience.filter(item => item?.category === 7)
    : []

  for (const alias of GENERAL_RISK_FIELD_ALIASES) {
    if (riskItems.some(item => item?.name === alias)) return alias
  }

  const byLabel = riskItems.find(item => includesGeneralRiskText(item?.label))
  if (byLabel?.name) return byLabel.name

  const byName = riskItems.find(item => includesGeneralRiskText(item?.name))
  if (byName?.name) return byName.name

  return fallback
}
